var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavViviendas = function SvgNavViviendas(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "nav_viviendas_svg__Capa_2",
    viewBox: "0 0 32.79 32.79"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nav_viviendas_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.01 31.41.04-6.4h0c1.07-4.6 7.62-4.6 8.69 0h0l.04 6.4",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: "1.5px",
    stroke: "#19d3c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.07 12.16v17.38a2.5 2.5 0 0 1-2.5 2.5H6.23a2.5 2.5 0 0 1-2.5-2.5V12.16m28.32 2.9L21.32 4.26C19 1.93 17.84.76 16.4.76s-2.6 1.17-4.92 3.5L.75 15.06",
    stroke: "#b3b3b3",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: "1.5px"
  }))));
};
export default SvgNavViviendas;